import React from "react";
import { Link } from "react-router-dom";

export default function AuthShell({ title, eyebrow, children, footer }) {
  return (
    <div style={{ minHeight: "100vh", display: "grid", gridTemplateColumns: "1fr", placeItems: "center", padding: 24 }}>
      <div style={{ width: "100%", maxWidth: 420 }}>
        <Link to="/" className="font-archivo" data-testid="auth-logo" style={{
          fontWeight: 900, textTransform: "uppercase", fontSize: 18, textDecoration: "none", color: "#0F1317",
          display: "block", marginBottom: 28, letterSpacing: "-0.02em",
        }}>
          Weekend AI Offer
        </Link>
        <div className="card-paper" style={{ padding: 32 }}>
          <div className="eyebrow" style={{ color: "#2038E6" }}>{eyebrow}</div>
          <h1 className="h-display" style={{ fontSize: 30, marginTop: 8, marginBottom: 22 }}>{title}</h1>
          {children}
        </div>
        {footer && <div style={{ marginTop: 18, textAlign: "center", fontSize: 14, color: "var(--muted)" }}>{footer}</div>}
      </div>
    </div>
  );
}

export const authInput = {
  border: "1px solid var(--line)", borderRadius: 10, padding: "13px 14px",
  fontSize: 16, fontFamily: "Inter, sans-serif", background: "#fff", width: "100%",
};
